import { Component, Input, AfterViewInit, OnDestroy, OnChanges } from '@angular/core';

export class ChNotificationComponent implements AfterViewInit, OnDestroy, OnChanges {

  time = 1000;
   messages = [];
  Interval: any;
  // @Input() set messages(mes) {
  //   this.messages = mes;
  // };

  // get messages() {
  //   return this.messages;
  // }

  constructor() { }

  ngAfterViewInit() {
    if (this.messages && this.messages.length > 0) {
      this.aotDisappear();
    }
  }

  remove(index: number, msgEl: any) {
    this.messages.splice(index, 1);
  }

  aotDisappear() {
    if (this.Interval) {
      clearInterval(this.Interval);
    }

    this.Interval = setInterval(() => {
      this.messages.forEach((item, index) => { if (!item.remain) { this.messages.splice(index, 1); }; });
      const len = this.messages.filter((item) => { return item.remain === true; });
      if (len.length < 1) { clearInterval(this.Interval); };
    }, this.time);
  }


  ngOnDestroy() {
    if (this.Interval) {
      clearInterval(this.Interval);
    }
  }

  ngOnChanges() {
    if (this.messages.length > 0) {
      this.aotDisappear();
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ch-notification',
  template: "\n    <div class=\"ch-notice\"><div #msgEl class=\"notice-content\" *ngFor=\"let item of messages; let i = index\" [ngClass]=\"{\n            'ch-notice-success': item.type == 'success',\n            'ch-notice-info': item.type == 'info',\n            'ch-notice-warn': item.type == 'warn',\n            'ch-notice-error': item.type == 'error'\n           }\"><a class=\"notice-close\" (click)=\"remove(i,msgEl)\"><i class=\"fa fa-times\"></i></a> <span class=\"notice-image fa fa-fw fa-2x\" [ngClass]=\"{\n             'fa-check': item.type == 'success',\n             'fa-info-circle': item.type == 'info',\n             'fa-warning': item.type == 'warn',\n             'fa-close': item.type == 'error'\n            }\"></span><div class=\"notice-message-item\"><span class=\"notice-titel\">{{item.title}}</span><p>{{item.text}}</p></div></div></div>\n  ",
  styles: ["\n    .ch-notice{position:fixed;top:90px;right:20px;width:22em;z-index:10}.ch-notice .notice-content{border:1px solid transparent;border-radius:4px;opacity:.95;margin-bottom:10px;padding:10px;color:#fff;position:relative}.ch-notice .notice-content .notice-close{color:#fff;cursor:pointer;position:absolute;top:5px;right:5px}.ch-notice .notice-content .notice-image{position:absolute;display:inline-block;left:.2em;top:.55em;padding:0}.ch-notice .notice-content .notice-message-item{padding:0 0 .25em 0;margin-left:2.5em}.ch-notice .notice-content .notice-message-item .notice-titel{font-weight:700;padding:0 0 .5em 0;display:block}\n  "]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'messages': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
